import Vuex from 'vuex';
import entryForm from './modules/entry-form';
import entryFormApi from './modules/entry-form-api';
import entryFormButtons from './modules/entry-form-buttons';
import entryFormConfiguration from './modules/entry-form-configuration';
import global from './modules/global';
import tableField from './modules/table-field';
import topPick from './modules/top-pick';

const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
  modules: {
    entryForm,
    entryFormApi,
    entryFormButtons,
    entryFormConfiguration,
    global,
    tableField,
    topPick
  },
  strict: debug
});
